module.exports = __webpack_public_path__ + "img/digital-experience-4.c0548c36.png";